import { createMemo } from "solid-js";
//
import { Table } from ":src/components/list";
import { EmptyTable } from "./empty-table";
import type { GradingData, TeamData, SubmissionStatus } from "../../_model";
import { global } from ":shared/app";

export type Props = {
  details: GradingData;
  filter: { search?: string; status?: SubmissionStatus };
  onEvaluate: (props: { item: TeamData; itemIndex: () => number }) => void;
};

export default function SubmissionsTable(props: Props) {
  const $teams = createMemo(() => {
    const result = [];
    const teams = props.details?.teams;
    if (teams == undefined || teams.length <= 0) {
      return undefined;
    }
    const filters = props.filter;
    if (filters == undefined) {
      return teams;
    }
    const { search, status } = filters;
    for (const index in teams) {
      const item = teams[index];
      const search_values = `${item.team_name},${item.project_name}`; // search keys
      let remove = false;
      if (search != undefined && !search_values.toLowerCase().includes(search)) {
        remove = true;
      } else if (status != undefined) {
        const has_score = item.scores != undefined;
        if (status === "done" && !has_score) {
          remove = true;
        } else if (status === "pending" && has_score) {
          remove = true;
        }
      }
      if (!remove) {
        result.push(item);
      }
    }
    return result;
  });
  const token = global.api.auth.events.getDecodedToken();
  const isJudge = token.user_key === "judge";

  return (
    <Table
      class="flex h-full text-black"
      _items={$teams()}
      _fallback={<EmptyTable msg="no submission to evaluate" />}
      _class={{
        desktop: {
          table: "px1",
          headersWrapper: "min-h-2rem bg-bg-alt font-semibold rounded-t-md items-center content-start mb-2",
          headersAndCells: "flex items-center justify-start text-0.75rem px-2 flex-1",
          rows: "py-1 mb-2",
        },
        phone: {
          wrapper: "gap-y-3 py-2 px-0.5",
          card: "items-center shadow-md py-3 px-2 gap-y-2 rounded-xl !justify-between text-0.74em",
          header: "w-100px items-center text-center ",
          cell: "flex justify-start items-center overflow-x-auto",
        },
      }}
      _containers={{
        items: ({ item, itemIndex, screen }) => {
          if (item.scores != undefined) {
            return {
              class: "!ring-success ring-2 ring-solid rounded-xl ",
            };
          }
          return {
            class: "!ring-border-card ring-2 ring-solid rounded-xl",
          };
        },
      }}
      _overlays={{
        items: ({ screen, item, itemIndex }) => {
          return (
            <div
              aria-label="item_name"
              class="w-full h-full rounded-xl cursor-pointer"
              onclick={() => {
                props.onEvaluate?.({ item, itemIndex });
              }}
            />
          );
        },
      }}
      _headers={{
        ID: {
          key: "id",
          class: {
            desktop: {
              headerAndCell: "!w-10px !pr-1",
            },
          },
        },
        "Team Name": {
          key: "team_name",
          class: {
            desktop: {
              header: "min-w-100px truncate",
            },
          },
        },
        Grade: {
          class: {
            desktop: {
              headerAndCell: "!min-w-150px truncate",
            },
          },
          key: ({ item }) => item?.scores?.total ?? "Not Graded",
          // key: ({ item }) => (isJudge ? item?.judging_score : item?.eval_score) ?? "Not Graded",
        },
        Status: {
          class: {
            phone: {
              cell: "h-40px",
            },
          },
          key: ({ item, screen }) => {
            const status = !item.scores ? "pending" : "done";
            return (
              <span
                class={
                  "capitalize rounded-xl text-0.8em h-fit px-2 py-1 " +
                  " " +
                  (status === "pending" ? "bg-warn-shade text-warn" : "bg-success-shade text-success")
                }
              >
                {status}
              </span>
            );
          },
        },
        "Evaluation Time": {
          class: {
            desktop: {
              headerAndCell: "!min-w-200px truncate",
            },
          },
          key: ({ item }) => item?.eval_time,
        },
      }}
    />
  );
}
